import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, CheckCircle, MessageCircle, Calculator } from 'lucide-react';
import { useLeadCapture } from '@/contexts/LeadCaptureContext';

const CallToAction = () => {
  const { openLeadForm } = useLeadCapture();

  return (
    <section id="demo" className="relative overflow-hidden py-20 md:py-28 bg-brand-azul text-white">
      <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-brand-roxo/30 blur-3xl" aria-hidden />
      <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-brand-rosa/20 blur-3xl" aria-hidden />

      <div className="container px-4 mx-auto relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-5xl font-extrabold mb-5 leading-tight">
            Quanto a dgenny vale
            <br />
            <span className="text-brand-rosa">pra sua construtora?</span>
          </h2>
          <p className="text-lg md:text-xl mb-12 text-white/80 max-w-xl mx-auto leading-relaxed">
            Em 1 minuto você recebe um diagnóstico com os seus números — quanto sua operação deixa na mesa hoje e o retorno projetado com a dgenny.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12 max-w-3xl mx-auto">
            {[
              'Saving potencial sobre o volume de compras',
              'Horas de cotação devolvidas pro seu time',
              'Redução de atrasos por problema de compra',
            ].map((text) => (
              <div key={text} className="bg-white/5 border border-white/10 rounded-xl p-5 backdrop-blur-sm">
                <CheckCircle className="h-5 w-5 text-brand-rosa mb-2 mx-auto" />
                <p className="text-white/90 text-sm leading-relaxed">{text}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/calculadora-roi">
              <Button
                size="lg"
                className="bg-brand-rosa text-brand-azul hover:brightness-105 font-bold rounded-full px-7"
              >
                <Calculator className="mr-2 h-4 w-4" />
                Calcular meu ROI agora
                <ArrowRight size={18} className="ml-1" />
              </Button>
            </Link>
            <button
              onClick={() => openLeadForm({
                redirectToWhatsApp: true,
                whatsAppMessage: 'Olá! Quero tirar algumas dúvidas sobre a dgenny antes de rodar o diagnóstico.',
              })}
              className="px-7 py-3 bg-white/10 border border-white/20 text-white font-semibold rounded-full hover:bg-white/15 transition inline-flex items-center justify-center gap-2 backdrop-blur"
            >
              <MessageCircle size={18} /> Tenho dúvidas primeiro
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
